import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import {
    GiftCardCheckOutDeliverable,
} from '@/b2c/shared/api/server-apis';
import CheckoutDeliverableItems from '@/b2c/checkout/ui/items/CheckoutDeliverableItems.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import CheckoutDeliverableGoToNext from '@/b2c/checkout/ui/CheckoutDeliverableGoToNext.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutGiftCardDeliverable',
  props: {
    deliverable: null,
    index: null
  },
  setup(__props: any) {



const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", null, [
      _createElementVNode("p", {
        class: "mb-x4 text-center",
        innerHTML: _unref(labels).giftCertificateInfo
      }, null, 8, _hoisted_1),
      (__props.deliverable.id)
        ? (_openBlock(), _createBlock(CheckoutDeliverableItems, {
            key: 0,
            deliverable: __props.deliverable
          }, null, 8, ["deliverable"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(CheckoutDeliverableGoToNext, {
      index: __props.index,
      deliverable: __props.deliverable
    }, null, 8, ["index", "deliverable"])
  ], 64))
}
}

})